"use strict";

// https://github.com/angular/angular.js/blob/master/src/ng/directive/ngEventDirs.js
angular.module("core").directive('wgClick', function(
    $parse, $rootScope, $exceptionHandler
) {
    return {
        restrict: 'A',
        compile: function($element, attr) {
            var fn = $parse(attr['wgClick']);
            return function ngEventHandler(scope, element) {
                element.on('click', function(event) {
                    if (event.detail && event.detail > 1) {
                        return;
                    }

                    var callback = function() {
                        fn(scope, {$event: event});
                    };

                    if (!$rootScope.$$phase) {
                        scope.$apply(callback);
                    }
                    else if (forceAsync) {
                        scope.$evalAsync(callback);
                    }
                    else {
                        try {
                            callback();
                        }
                        catch (error) {
                            $exceptionHandler(error);
                        }
                    }
                });
            };
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/wg-click/wg-click.directive.js
// module id = 482
// module chunks = 0